import _ from 'lodash';

export default () => ({
    error: null,
    loading: false,
    async fetchCity(postalCode) {
        const response = await fetch(`https://api.zippopotam.us/HU/${postalCode}`);
        if (response.status === 404) {
            return '';
        }
        if (!response.ok) {
            console.error(await response.json());
            throw new Error();
        }
        const json = await response.json();
        if (json?.places) {
            json.places.sort((a, b) => a['place name'].localeCompare(b['place name']));
            return json.places[0]['place name'];
        }
        return '';
    },
    async setCity(countryField, postalCodeField, cityField) {
        const country = _.get(this, countryField);
        const postalCode = _.get(this, postalCodeField);

        if (!['Magyarország', 'Hungary'].includes(country)) return;
        if (postalCode.length !== 4) return;
        this.loading = true;
        try {
            const result = await this.fetchCity(postalCode);
            if (result) {
                _.set(this, cityField, result);
            }
        } catch (e) {
            this.error = 'Hiba történt a lekérdezés során!';
        }
        this.loading = false;
    }
})